<div *ngIf="!configMode" class="non-config-mode-container">
    <div class="value aza-pa-primary-color">{{definition.data || "-"}}</div>
</div>

<div *ngIf="configMode" class="config-mode-container">
    <div class="settings-container">
        <div class="setting-item">
            <mat-form-field>
                <mat-select (selectionChange)="onCountTypeChanged()" [(value)]="definition.settings.local.countType"
                    placeholder="{{'COUNT_TYPE' | translate}}">
                    <mat-option value="events"><span translate>EVENTS</span></mat-option>
                    <mat-option value="contacts"><span translate>CONTACTS</span></mat-option>
                    <mat-option value="organizations"><span translate>ORGANIZATIONS</span></mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="setting-item">
            <azavista-flat-button *ngIf="filterFields" (click)="onShowFilter()">
                <span translate>FILTER</span>
            </azavista-flat-button>
        </div>
    </div>
    <div class="preview-container">
    </div>
</div>
